import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader flex-column"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bold mt-5" }, "Carregando...", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "page-loader flex-column"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border text-white",
    role: "status"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white fs-6 fw-bold ms-5" }, "Carregando...")
], -1)
const _hoisted_8 = {
  key: 2,
  class: "page-loader"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaderType === 'spinner-message')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_ctx.loaderType === 'spinner-logo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            alt: "Logo",
            class: "max-h-75px",
            src: _ctx.logo
          }, null, 8, _hoisted_6),
          _hoisted_7
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
}